import type { ReactNode } from 'react';

import { Icon, type IconName } from '@/components/ui/Icon';
import { cn } from '@/utils/cn';

import styles from './Alert.module.css';

export type AlertTone = 'info' | 'success' | 'warning' | 'danger';

const ICONS: Record<AlertTone, IconName> = {
  info: 'info',
  success: 'check',
  warning: 'alert',
  danger: 'alert',
};

export interface AlertProps {
  tone?: AlertTone;
  title?: string;
  children?: ReactNode;
  className?: string | undefined;
}

/** An inline message inside a form or card — e.g. why a save failed. */
export function Alert({ tone = 'info', title, children, className }: AlertProps) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(styles.alert, styles[tone], className)}
    >
      <Icon name={ICONS[tone]} size={20} className={styles.icon} />
      <div className={styles.content}>
        {title && <p className={styles.title}>{title}</p>}
        {children !== undefined && <div className={styles.body}>{children}</div>}
      </div>
    </div>
  );
}
